export const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export const isSmallScreen = (): boolean => {
  if (typeof window === 'undefined') return true;
  return window.innerWidth < 640;
};
